import styled from 'styled-components';

import { pxToRem } from '@yoweb/ui/styles/utils';
import { Spinner } from '@yoweb/ui/components/Spinner';

export const IDS = {
  SPINNER: 'lp-spinner',
};

/**
 * A full height block with a spinner used to represent a loading page.
 */
export const LoadingPage = () => (
  <SpinnerOuter data-testid={IDS.SPINNER}>
    <SpinnerContainer>
      <Spinner data-testid="loading-spinner" />
    </SpinnerContainer>
  </SpinnerOuter>
);

const SpinnerOuter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${pxToRem(150)};
  width: ${pxToRem(150)};
`;

export default LoadingPage;
